import {Component, Input} from '@angular/core';
import {MotifAccordPrealableTableListeMetierService} from './motif-accord-prealable-table.liste.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';

@Component({
  selector: 'app-motif-accord-prealable-table-liste',
  templateUrl: './motif-accord-prealable-table.liste.component.html'
})

export class MotifAccordPrealableTableListeComponent extends SgiListLayoutComponent {
  @Autowired() recuperationListeDonneesMetier: MotifAccordPrealableTableListeMetierService;

  @Input('currentDataUser') currentDataUser: any;

  constructor() {
    super();
    this.cols = [
      { field: 'libelle', header: 'Libellé' },
    ];

    this.tableActions = [];
  }

  ngOnInit(): void {
    if (this.currentDataUser) {
      this.recuperDonnees();
    }
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args, currentDataUser: this.currentDataUser};
    this.args = {...arg};
  }

}
